import { gql } from '@apollo/client'

export const PATCH_CUSTOMPROPS = gql`
    mutation patchCustomProps($input: [CustomPropsInput!]!) {
        patchCustomerProps(input: $input)
    }
`
